<template>
  <div>
    Placeholder
  </div>
</template>

<script>
export default {
  name: 'gcusettings'
};
</script>

<style>

</style>
